import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Reusable About/Info section layout
 * - Left: Image
 * - Right: Title, description, meta points, CTA button
 * - API friendly: just pass `data`
 */
const AboutSplitCard = ({ data, onAction }) => {

  return (
    <div
      className="
        grid grid-cols-1 sm:grid-cols-2 gap-4
        p-4 sm:p-5
      "
    >
      {/* LEFT: Image */}
      <div className="relative overflow-hidden rounded-2xl bg-gray-100 min-h-[220px] sm:min-h-[260px]">
        {data?.image ? (
          <img
            src={data?.image}
            alt={data?.key || "about"}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="h-full w-full animate-pulse bg-gray-200" />
        )}

        {/* subtle overlay badge (optional) */}
        <div className="absolute left-3 top-3 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-gray-700 backdrop-blur">
          About
        </div>
      </div>

      {/* RIGHT: Content */}
      <div className="flex flex-col  gap-3">
       <p className=" text-start!" dangerouslySetInnerHTML={{__html:data?.label}}></p>

        {/* CTA */}
        <div className="flex flex-wrap items-center justify-end gap-2">
      
            <a
             href={data?.path}
             target="_blank"
             rel="noreferrer"
              className="
                inline-flex items-center justify-center
                rounded-lg px-4 py-2 text-[13px] font-semibold border border-[#9d2e43]
                 bg-transparent text-[#9d2e43] hover:text-white hover:bg-[#9d2e43] transition
              "
            >
            Visit on site
            </a>
         
        </div>
      </div>
    </div>
  );
};

export default AboutSplitCard;
